import React from 'react';
import { Modal } from 'react-bootstrap';

class ConfirmModal extends React.Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.state = { showModal: false };
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  render() {
    const {
      title, trigger, triggerInfo, children, confirm, close,
    } = this.props;

    const { showModal } = this.state;

    return (
      <div style={{ display: 'inline' }}>
        {trigger(this.open, triggerInfo)}
        <Modal key="modal" show={showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>
              {title || 'Emin misiniz?'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {children}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-success"
              onClick={() => confirm(this.close)}
            >
                            Tamam
            </button>
            <button
              className="btn btn-danger"
              onClick={close ? () => { close(this.close); } : this.close}
            >
                            Kapat
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/common/modal/confirm/index.js